import safeCallWithNull from './safe-call-with-null';
/**
 * 异步加载脚本，可用于异步加载 JS 或发起 JSONP 请求。
 *
 * @param {string} path JS 脚本地址
 * @param {(result: boolean|null) => void} cb 回调函数，成功返回 true，失败返回 false，超时返回 null
 * @param {string} [charset] 字符集，默认 utf-8
 * @param {number} [timeout] 超时时间，单位为秒
 * @returns
 */
export default function loadScript(path, cb, charset, timeout) {
    var $head = document.getElementsByTagName('head')[0];
    var $script = document.createElement('script');
    var timeoutHandler = null;
    var _eventHandlerLoad = function () {
        _cancelScript();
        safeCallWithNull(cb, true);
    };
    /* istanbul ignore next: onerror 事件才会触发 */
    var _eventHandlerError = function () {
        _cancelScript();
        safeCallWithNull(cb, false);
    };
    var _cancelScript = function () {
        /* istanbul ignore next */
        if (!$script) {
            return;
        }
        try {
            $script.src = '';
        }
        catch (_) { }
        $script.removeEventListener('load', _eventHandlerLoad);
        $script.removeEventListener('error', _eventHandlerError);
        $head.removeChild($script);
        $script = null;
        if (timeoutHandler) {
            clearTimeout(timeoutHandler);
            timeoutHandler = null;
        }
    };
    $script.addEventListener('load', _eventHandlerLoad);
    $script.addEventListener('error', _eventHandlerError);
    $script.charset = charset || 'utf-8';
    $script.src = path;
    $head.insertBefore($script, $head.firstChild);
    if (timeout) {
        timeoutHandler = window.setTimeout(function () {
            _cancelScript();
            safeCallWithNull(cb, null);
        }, timeout * 1000);
    }
    return $script;
}
//# sourceMappingURL=load-script.js.map